var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoveArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 22,
    viewBox: "0 0 10 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82307 6.27613L7.99985 6.45291L8.17662 6.27613L9.17657 5.27618L9.35335 5.09941L9.17657 4.92263L5.17678 0.922833L5 0.746056L4.82322 0.922833L0.823427 4.92263L0.64665 5.09941L0.823427 5.27618L1.82338 6.27613L2.00015 6.45291L2.17693 6.27613L4.04208 4.41098L4.04254 10.9998L4.04255 11.2498H4.04302L4.04258 17.5877L2.17693 15.7221L2.00015 15.5453L1.82338 15.7221L0.823427 16.722L0.64665 16.8988L0.823427 17.0756L4.82322 21.0754L5 21.2522L5.17678 21.0754L9.17657 17.0756L9.35335 16.8988L9.17657 16.722L8.17662 15.7221L7.99989 15.5453L7.82311 15.722L5.95696 17.5874L5.95696 10.9989L5.95696 10.7489H5.9565L5.95738 4.41044L7.82307 6.27613Z",
    fill: "#52509A",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveArrow);
export default __webpack_public_path__ + "static/media/move-arrow.9bb29ea5fb2f5ddf379402501b13c35d.svg";
export { ForwardRef as ReactComponent };